import type { IconProps } from './types';

export const ChartIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M2.625 1.6875V21.375H22.3125M7.3125 9.1875V18.5625M12 4.5V18.5625M16.6875 12.9375V18.5625"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
